import { z } from 'zod';
import { ReadNucleoDto } from '@/api.types';
import { normalizeNucleoFormFromApi } from '@/modules/structure/nucleo/nucleo-form.utils';
import {
  optionalReferenceIdSchema,
  requiredIntFromNumberInput,
  requiredReferenceIdSchema,
  telefoneFormSchema,
} from '@/shared/utils/formZod.schema.utils';

function nullToEmpty(val: unknown): string {
  return val == null ? '' : String(val);
}

const optionalNullableStringSchema = z.preprocess(nullToEmpty, z.string().optional());

const nucleoFormBaseSchema = z
  .object({
    ordem: requiredIntFromNumberInput({
      requiredMessage: 'Informe a ordem',
      min: 0,
      minMessage: 'A ordem deve ser zero ou maior',
    }),
    nome: z.string().trim().min(1, 'Informe o nome do núcleo'),
    resolucao: optionalNullableStringSchema,
    maximoIntegrantes: requiredIntFromNumberInput({
      requiredMessage: 'Informe o máximo de estagiários',
      min: 0,
      max: 99,
      minMessage: 'Mínimo 0',
      maxMessage: 'Máximo 99',
    }),
    maximoMembros: requiredIntFromNumberInput({
      requiredMessage: 'Informe o máximo de membros',
      min: 0,
      max: 99,
      minMessage: 'Mínimo 0',
      maxMessage: 'Máximo 99',
    }),
    comarca: requiredReferenceIdSchema,
    predio: requiredReferenceIdSchema,
    substituto1: optionalReferenceIdSchema,
    substituto2: optionalReferenceIdSchema,
    diretoria: optionalReferenceIdSchema,
    telefone: telefoneFormSchema,
  })
  .passthrough();

/** Campos validados no formulário de cadastro/edição (CreateNucleoDto / UpdateNucleoDto). */
export const nucleoFormSchema = z.preprocess(
  (val) =>
    val != null && typeof val === 'object'
      ? normalizeNucleoFormFromApi(val as ReadNucleoDto)
      : val,
  nucleoFormBaseSchema,
);

export type NucleoFormValues = z.infer<typeof nucleoFormBaseSchema>;
